import request from '@/utils/request'
import qs from 'qs'

const urlPrefix = '/inventory'

// host
export function updateHostInventory (id, data) {
  return request.put(`${urlPrefix}/hosts/${id}`, data)
}

export function createHostInventory (data) {
  return request.post(`${urlPrefix}/hosts`, data)
}

export function deleteHostInventory (id) {
  return request.delete(`${urlPrefix}/hosts/${id}`)
}

export function getHostInventory (id) {
  return request.get(`${urlPrefix}/hosts/${id}`)
}

export function getHostInventoryList (params) {
  return request.get(`${urlPrefix}/hosts`, { params })
}

export function checkHostInventory () {
  return request.get(`${urlPrefix}/hosts/check`)
}

export function importHostInventory (data) {
  return request.post(`${urlPrefix}/hosts/import`, data)
}

export function exportHostInventory (params) {
  return request({
    url: `${urlPrefix}/hosts/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}

export function getHostCount (params) {
  return request.get(`${urlPrefix}/hosts/count`, { params })
}

// software
export function updateSoftwareInventory (id, data) {
  return request.put(`${urlPrefix}/softwares/${id}`, data)
}

export function createSoftwareInventory (data) {
  return request.post(`${urlPrefix}/softwares`, data)
}

export function deleteSoftwareInventory (id) {
  return request.delete(`${urlPrefix}/softwares/${id}`)
}

export function getSoftwareInventory (id) {
  return request.get(`${urlPrefix}/softwares/${id}`)
}

export function getSoftwareInventoryList (params) {
  return request.get(`${urlPrefix}/softwares`, { params })
}

export function checkSoftwareInventory () {
  return request.get(`${urlPrefix}/softwares/check`)
}

export function importSoftwareInventory (data) {
  return request.post(`${urlPrefix}/softwares/import`, data)
}

export function exportSoftwareInventory (params) {
  return request({
    url: `${urlPrefix}/softwares/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}

export function getSoftwareCount (params) {
  return request.get(`${urlPrefix}/softwares/count`, { params })
}

// hardware
export function updateHardwareInventory (id, data) {
  return request.put(`${urlPrefix}/hardwares/${id}`, data)
}

export function createHardwareInventory (data) {
  return request.post(`${urlPrefix}/hardwares`, data)
}

export function deleteHardwareInventory (id) {
  return request.delete(`${urlPrefix}/hardwares/${id}`)
}

export function getHardwareInventory (id) {
  return request.get(`${urlPrefix}/hardwares/${id}`)
}

export function getHardwareInventoryList (params) {
  return request.get(`${urlPrefix}/hardwares`, { params })
}

export function checkHardwareInventory () {
  return request.get(`${urlPrefix}/hardwares/check`)
}

export function importHardwareInventory (data) {
  return request.post(`${urlPrefix}/hardwares/import`, data)
}

export function exportHardwareInventory (params) {
  return request({
    url: `${urlPrefix}/hardwares/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}
export function getHardwareCount (params) {
  return request.get(`${urlPrefix}/hardwares/count`, { params, timeout: 60 * 1000 * 3 })
}

// service
export function updateServiceInventory (id, data) {
  return request.put(`${urlPrefix}/services/${id}`, data)
}

export function createServiceInventory (data) {
  return request.post(`${urlPrefix}/services`, data)
}

export function deleteServiceInventory (id) {
  return request.delete(`${urlPrefix}/services/${id}`)
}

export function getServiceInventoryList (params) {
  return request.get(`${urlPrefix}/services`, { params })
}

export function getServiceInventory (id) {
  return request.get(`${urlPrefix}/services/${id}`)
}

export function checkServiceInventory () {
  return request.get(`${urlPrefix}/services/check`)
}

export function importServiceInventory (data) {
  return request.post(`${urlPrefix}/services/import`, data)
}

export function exportServiceInventory (params) {
  return request({
    url: `${urlPrefix}/services/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}

export function getServiceCount (params) {
  return request.get(`${urlPrefix}/services/count`, { params })
}

// operation-company
export function updateOperationCompany (id, data) {
  return request.put(`${urlPrefix}/operation-companies/${id}`, data)
}

export function createOperationCompany (data) {
  return request.post(`${urlPrefix}/operation-companies`, data)
}

export function deleteOperationCompany (id) {
  return request.delete(`${urlPrefix}/operation-companies/${id}`)
}

export function getOperationCompanyList (params) {
  return request.get(`${urlPrefix}/operation-companies`, { params })
}

export function getOperationCompany (id) {
  return request.get(`${urlPrefix}/operation-companies/${id}`)
}

export function checkOperationCompany () {
  return request.get(`${urlPrefix}/operation-companies/check`)
}

export function importOperationCompany (data) {
  return request.post(`${urlPrefix}/operation-companies/import`, data)
}

export function exportOperationCompany (params) {
  return request({
    url: `${urlPrefix}/operation-companies/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}

// public-ip
export function updatePublicIpInventory (id, data) {
  return request.put(`${urlPrefix}/public-ips/${id}`, data)
}

export function createPublicIpInventory (data) {
  return request.post(`${urlPrefix}/public-ips`, data)
}

export function deletePublicIpInventory (id) {
  return request.delete(`${urlPrefix}/public-ips/${id}`)
}

export function getPublicIpInventory (id) {
  return request.get(`${urlPrefix}/public-ips/${id}`)
}

export function getPublicIpInventoryList (params) {
  return request.get(`${urlPrefix}/public-ips`, { params })
}

export function checkPublicIpInventory () {
  return request.get(`${urlPrefix}/public-ips/check`)
}

export function importPublicIpInventory (data) {
  return request.post(`${urlPrefix}/public-ips/import`, data)
}

export function exportPublicIpInventory (params) {
  return request({
    url: `${urlPrefix}/public-ips/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}

// port-map
export function updatePortMapInventory (id, data) {
  return request.put(`${urlPrefix}/port-maps/${id}`, data)
}

export function createPortMapInventory (data) {
  return request.post(`${urlPrefix}/port-maps`, data)
}

export function deletePortMapInventory (id) {
  return request.delete(`${urlPrefix}/port-maps/${id}`)
}

export function getPortMapInventoryList () {
  return request.get(`${urlPrefix}/port-maps`)
}

export function getPortMapInventory (id) {
  return request.get(`${urlPrefix}/port-maps/${id}`)
}

export function checkPortMapInventory () {
  return request.get(`${urlPrefix}/port-maps/check`)
}

export function importPortMapInventory (data) {
  return request.post(`${urlPrefix}/port-maps/import`, data)
}

export function exportPortMapInventory (params) {
  return request({
    url: `${urlPrefix}/port-maps/export`,
    responseType: 'blob',
    method: 'get',
    params,
    paramsSerializer: obj => {
      return qs.stringify(obj, { arrayFormat: 'repeat' })
    }
  })
}
